import type { ColumnDef } from "@tanstack/react-table";
import { AddedDate } from "@/accounts-payable/common";
import type { ApInvoice } from "@/accounts-payable/types";

export const addedCol: ColumnDef<ApInvoice> = {
  accessorKey: "created_at",
  // "Added", not "Received": in AP, received reads as the goods arriving
  // (a ServiceTitan receipt). This is when the invoice reached Volca.
  header: () => (
    <span title="When this invoice was added to Volca, by email or upload">
      Added
    </span>
  ),
  meta: { size: "120px" },
  cell: ({ row }) => <AddedDate value={row.original.created_at} />,
};
